import StyledStepperControls from './styles';

export default StyledStepperControls;
